<ng-container
  *ngIf="
    subProject.expectedType === SUB_PROJECT_TYPES.BASE_PROJECT;
    else showAdjustmentCompletion
  "
>
  <div class="completion-container">
    <ng-container *ngTemplateOutlet="baseProjectCompletion"></ng-container>
  </div>
</ng-container>
<ng-template #showAdjustmentCompletion>
  <div class="completion-container">
    <ng-container *ngTemplateOutlet="adjustmentCompletion"></ng-container>
  </div>
</ng-template>

<!-- COMPLETION SECTIONS -->

<ng-template #baseProjectCompletion>
  <ng-container *ngIf="firstIPBoardWrapper?.ipBoard?.productPlacement != null">
    <div class="d-flex w-100">
      <div class="completion-content-container">
        <div class="d-flex upper-space">
          <div class="align-textarea-label">
            <div class="font-16 secondary-color strong">Opmerkingen</div>
          </div>
          <div class="left-space flexer">
            <textarea-input
              [initContent]="
                firstIPBoardWrapper.ipBoard.productPlacement.installerFeedback
              "
              [placeholder]="'Feedback installateur'"
              [disabled]="true"
              [client]="true"
            ></textarea-input>
          </div>
        </div>
        <div class="to-do-item-container half-width">
          <div class="to-do-item">
            <mat-checkbox disabled [(ngModel)]="firstIPBoardWrapper.placed.done"
              ><span class="strong">{{
                firstIPBoardWrapper.placed.label | shortenText : 30
              }}</span></mat-checkbox
            >
          </div>
          <div *ngIf="firstIPBoardWrapper.text != null" class="to-do-item">
            <mat-checkbox disabled [(ngModel)]="firstIPBoardWrapper.text.done"
              ><span class="strong">{{
                firstIPBoardWrapper.text.label
              }}</span></mat-checkbox
            >
          </div>
          <div *ngIf="firstIPBoardWrapper.leftTitle != null" class="to-do-item">
            <mat-checkbox
              disabled
              [(ngModel)]="firstIPBoardWrapper.leftTitle.done"
              ><span class="strong">{{
                firstIPBoardWrapper.leftTitle.label
              }}</span></mat-checkbox
            >
          </div>
          <div
            *ngIf="firstIPBoardWrapper.rightTitle != null"
            class="to-do-item"
          >
            <mat-checkbox
              disabled
              [(ngModel)]="firstIPBoardWrapper.rightTitle.done"
              ><span class="strong">{{
                firstIPBoardWrapper.rightTitle.label
              }}</span></mat-checkbox
            >
          </div>
          <div
            *ngIf="firstIPBoardWrapper.leftPhoneNumber != null"
            class="to-do-item"
          >
            <mat-checkbox
              disabled
              [(ngModel)]="firstIPBoardWrapper.leftPhoneNumber.done"
              ><span class="strong">{{
                firstIPBoardWrapper.leftPhoneNumber.label
              }}</span></mat-checkbox
            >
          </div>
          <div
            *ngIf="firstIPBoardWrapper.rightPhoneNumber != null"
            class="to-do-item"
          >
            <mat-checkbox
              disabled
              [(ngModel)]="firstIPBoardWrapper.rightPhoneNumber.done"
              ><span class="strong">{{
                firstIPBoardWrapper.rightPhoneNumber.label
              }}</span></mat-checkbox
            >
          </div>
          <div *ngIf="firstIPBoardWrapper.sticker != null" class="to-do-item">
            <mat-checkbox
              disabled
              [(ngModel)]="firstIPBoardWrapper.sticker.done"
              ><span class="strong">{{
                firstIPBoardWrapper.sticker.label
              }}</span></mat-checkbox
            >
          </div>
          <div *ngIf="firstIPBoardWrapper.poleColor != null" class="to-do-item">
            <mat-checkbox
              disabled
              [(ngModel)]="firstIPBoardWrapper.poleColor.done"
              ><span class="strong"
                >{{ firstIPBoardWrapper.poleColor.label }} hout</span
              ></mat-checkbox
            >
          </div>
          <div *ngIf="firstIPBoardWrapper.immoscoop != null" class="to-do-item">
            <mat-checkbox
              [ariaLabel]=""
              disabled
              [(ngModel)]="firstIPBoardWrapper.immoscoop.done"
              ><span class="strong">{{
                firstIPBoardWrapper.immoscoop.label
              }}</span></mat-checkbox
            >
          </div>
          <div *ngIf="firstIPBoardWrapper.spotto != null" class="to-do-item">
            <mat-checkbox
              [ariaLabel]=""
              disabled
              [(ngModel)]="firstIPBoardWrapper.spotto.done"
              ><span class="strong">{{
                firstIPBoardWrapper.spotto.label
              }}</span></mat-checkbox
            >
          </div>
          <div
            *ngIf="firstIPBoardWrapper.extraHeight != null"
            class="to-do-item"
          >
            <mat-checkbox
              [ariaLabel]=""
              disabled
              [(ngModel)]="firstIPBoardWrapper.extraHeight.done"
              ><span class="strong">{{
                firstIPBoardWrapper.extraHeight.label
              }}</span></mat-checkbox
            >
          </div>
          <div *ngIf="firstIPBoardWrapper.extras != null" class="to-do-item">
            <mat-checkbox
              [ariaLabel]=""
              disabled
              [(ngModel)]="firstIPBoardWrapper.extras.done"
              ><span class="strong">{{
                firstIPBoardWrapper.extras.label
              }}</span></mat-checkbox
            >
          </div>
          <div *ngIf="subProjectToDoItems?.extras != null" class="to-do-item">
            <mat-checkbox disabled [(ngModel)]="subProjectToDoItems.extras.done"
              ><span class="strong">{{
                subProjectToDoItems.extras.label
              }}</span></mat-checkbox
            >
          </div>
        </div>
      </div>
      <div
        *ngIf="subProject?.executionPictures?.length > 0"
        class="completion-pictures-container left-space"
      >
        <immo-ip-placer-project-completion-pictures
          [executionPictures]="subProject.executionPictures"
        ></immo-ip-placer-project-completion-pictures>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #adjustmentCompletion>
  <div class="d-flex w-100">
    <div class="completion-content-container">
      <div class="d-flex upper-space">
        <ng-container *ngIf="subProject.projectPlacement != null">
          <div class="align-textarea-label">
            <div class="font-16 secondary-color strong">Opmerkingen</div>
          </div>
          <div class="left-space flexer">
            <textarea-input
              [initContent]="subProject.projectPlacement.placerFeedback"
              [placeholder]="'Feedback installateur'"
              disabled
              [client]="true"
            ></textarea-input>
          </div>
        </ng-container>
      </div>
      <div class="d-flex">
        <div class="flex-0-5">
          <div class="to-do-item-container">
            <div
              *ngIf="subProjectToDoItems?.completed != null"
              class="to-do-item"
            >
              <div class="align-checkbox flex-0-6">
                <mat-checkbox
                  [ariaLabel]=""
                  disabled
                  [(ngModel)]="subProjectToDoItems.completed.done"
                  ><span class="strong">{{
                    subProjectToDoItems.completed.label
                  }}</span></mat-checkbox
                >
              </div>
            </div>
            <div
              *ngIf="subProjectToDoItems?.stickerInfo != null"
              class="to-do-item"
            >
              <div class="align-checkbox flex-0-6">
                <mat-checkbox
                  [ariaLabel]=""
                  disabled
                  [(ngModel)]="subProjectToDoItems.stickerInfo.done"
                  ><span class="strong">{{
                    subProjectToDoItems.stickerInfo.label
                  }}</span></mat-checkbox
                >
              </div>
            </div>
            <div *ngIf="subProjectToDoItems?.extras != null" class="to-do-item">
              <div class="align-checkbox flex-0-6">
                <mat-checkbox
                  [ariaLabel]=""
                  disabled
                  [(ngModel)]="subProjectToDoItems.extras.done"
                  ><span class="strong">{{
                    subProjectToDoItems.extras.label
                  }}</span></mat-checkbox
                >
              </div>
            </div>
          </div>
        </div>
        <div class="flex-0-5">
          <ng-container *ngIf="subProject.type === SUB_PROJECT_TYPES.REPO">
            <div class="flex-to-bottom-right">
              <div class="font-16 secondary-color strong">
                Ruim alles op & laat de werkplek netjes achter
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div
      *ngIf="subProject?.executionPictures?.length > 0"
      class="completion-pictures-container left-space"
    >
      <immo-ip-placer-project-completion-pictures
        [executionPictures]="subProject.executionPictures"
      ></immo-ip-placer-project-completion-pictures>
    </div>
  </div>
</ng-template>
